import { connect } from 'react-redux'
import MyFilesEntry from './my-files-entry'
import { getMyFile } from '../../../../../../stores/my-files/my-files.selectors'
import { format } from 'date-fns'

const mapStateToProps = (state, { id }) => {
  const myFile = getMyFile(state, id)
  return {
    id: myFile.id,
    title: myFile.title,
    createdAt: format(myFile.created_at, 'DD.MM.YYYY'),
    link: `/assessment-files/${myFile.id}`,
    conclusion: myFile.concluded,
    moderationType:
      myFile.moderation_type && myFile.moderation_type.replace(/_/g, ' '),
    judgement: myFile.judgement && myFile.judgement.replace(/_/g, ' '),
    judgementShort: checkJudgment(myFile.judgement),
    students:
      myFile.student_types &&
      myFile.student_types
        .map(student => student.account.full_name + ', ')
        .toString()
        .slice(0, -2),
    thumb:
      myFile.works &&
      myFile.works[0] &&
      myFile.works[0].media &&
      myFile.works[0].media[0] &&
      myFile.works[0].media[0].thumb_url,
    ageGroupTitle:
      myFile.student_types &&
      myFile.student_types[0] &&
      myFile.student_types[0].year_group &&
      myFile.student_types[0].year_group.title,
    ageGroupOrder:
      myFile.student_types &&
      myFile.student_types[0] &&
      myFile.student_types[0].year_group &&
      myFile.student_types[0].year_group.order
  }
}

function checkJudgment(judgement) {
  return judgement === 'greater_depth_within_the_expected_standard'
    ? 'GDS'
    : judgement === 'working_towards_the_expected_standard'
    ? 'WTS'
    : judgement === 'working_at_the_expected_standard'
    ? 'EXS'
    : judgement === 'eyfs_emerging'
    ? 'EYFS Emerging'
    : judgement === 'eyfs_expected'
    ? 'EYFS Expected'
    : '-'
}

export default connect(
  mapStateToProps,
  null
)(MyFilesEntry)
